import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// html5-qrcode interrupts the <video>.play() promise when the scanner stops;
// swallow that specific error so the dev overlay doesn't block the UI (harmless).
const isPlayInterrupt = (v) => {
  const msg = String((v && v.message) || v || "");
  return msg.includes("play() request was interrupted") || msg.includes("The play() request");
};
window.addEventListener("unhandledrejection", (e) => {
  if (isPlayInterrupt(e && e.reason)) { e.preventDefault(); e.stopImmediatePropagation(); }
}, true);
window.addEventListener("error", (e) => {
  if (isPlayInterrupt(e && (e.error || e.message))) { e.preventDefault(); e.stopImmediatePropagation(); }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
